import { useEffect } from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import { Form, Input, Button } from "antd";

import Service from '../../service/Mgt-org'
import Actions from "../../redux/actions";
import FormControl from "../../component/form/FormControl";

import moment from "moment";
import "moment/locale/th";
moment.locale("th");


const FormExtend = styled(FormControl)`
    .form-button{
    padding-left: 0;
    padding-right: 0;
    button{
        width: 40%;
        color: white;
        background-color: #007BFF ;
    }

    button:hover{
        background-color: white;
        color : #007BFF;
        border-radius: 5px;
        transition: 0.3s;
    }
    }
    .form-item__btn-cancel{
        background-color: #1d1d1d !important;
    }
    .form-item__btn-cancel:hover{
        background-color: white !important;
        color : #1d1d1d;
        border-radius: 5px;
        transition: 0.3s;
        border-color: #1d1d1d;
    }
`;

export default function FormAddOrg(props) {
    const dispatch = useDispatch()
    const [form] = Form.useForm();
    useEffect(() => {
        const init = async () => {
            form.setFieldsValue({ status: 1 })
            if (props.orgId) {
                let orgs = await Service.detail(props.orgId)
                if (orgs) {
                    form.setFieldsValue({
                        name: orgs.name,
                        dispName: orgs.disp_name,
                    })
                }
            }
        }

        init()
    }, [form, props.orgId]);

    const onFinish = async (values) => {
        if (props.orgId) {
            let result = await Service.update(props.orgId, values)
            if (result) {
                dispatch(Actions.MgtOrg.updateOrg(result))
                dispatch(Actions.popup.toggleVisible(false))
            }
        } else {
            let result = await Service.create(values)
            if (result) {
                dispatch(Actions.MgtOrg.addOrg(result))
                dispatch(Actions.popup.toggleVisible(false))
            }
        }
    };

    const formInput = () => {
        return (
            <>           
                <Form.Item
                    name={["name"]}
                    className="form-item__name"
                    label="ชื่อ"
                    rules={[{ required: true }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    name={["dispName"]}
                    className="form-item__dispName"
                    label="ชื่อที่ใช้แสดง"
                    rules={[{ required: true }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item className="form-button">
                    {props.orgId ?
                        (props.permission.indexOf('update') >= 0 ? (<Button className="form-item__btn-submit btn-primary" htmlType="submit">อัพเดทข้อมูล</Button>) : (<></>))
                        :
                        (props.permission.indexOf('create') >= 0 ? (<Button className="form-item__btn-submit btn-primary" htmlType="submit">สร้างหน่วยงาน/องค์กร</Button>) : (<></>))}
                    <Button className="form-item__btn-cancel" onClick={() => { dispatch(Actions.popup.toggleVisible(false)) }}>
                        ยกเลิก
                    </Button>
                </Form.Item>
            </>
        );
    };

    return (
        <FormExtend
            name={"form-crate-org"}
            column={2}
            inputs={formInput}
            onFinish={props.onFinish ? props.onFinish : onFinish}
            form={form}
            className={props.className ? props.className : "popup-form-mgt-org"}
        ></FormExtend>
    );
}
